export function jobInitialData(collectionId: number, webuserId: number, importId: number) {
    return {
        collection_id: collectionId,
        address_id: null,
        client_attributes: {
            city: '',
            house: '',
            pcode: '',
            street: '',
            country: 'Polska',
            quarter: '',
            province: '',
            community: '',
        },
        address_attributes: {
            city: '',
            house: '',
            pcode: '',
            street: '',
            country: 'Polska',
            quarter: '',
            province: '',
            community: '',
        },
        special_attributes: {},
        geom: null,
    };
}
